import React, { useMemo, useCallback } from "react";
import { Button } from "primereact/button";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { fetchWithAuth, API_URL } from "./fetchWithAuth";

const BotonesHistorico = React.memo(
  ({ rowData, translations, onVer, showMessage }) => {
    const estado = rowData.sNombreEstadoPedido;

    /* const handleCargar = useCallback(() => {
        if (!['CREADO', 'LE_OK'].includes(estado)) {
            showMessage('warn', translations.accionnopermitida, translations.pedidonopuedesereditado);
            return;
        }
        onCargar(rowData);
    }, [estado, onCargar, rowData, showMessage, translations]); */

    /* const handleAprobar = useCallback(() => {
        if (estado === 'LE_APROBADA') {
            showMessage('error', translations.estadoincorrecto, translations.listaaprobada);
            return;
        }
        if (estado !== 'LE_OK') {
            showMessage('error', translations.estadoincorrecto, translations.pedidodebeserleok);
            return;
        }

        confirmDialog({
            message: translations.aprobarlistaempaque,
            header: translations.text_Confirmacion,
            icon: 'pi pi-question-circle',
            acceptClassName: 'p-button-primary',
            rejectClassName: 'p-button-outlined',
            acceptLabel: translations.yesbutton,
            rejectLabel: translations.nobutton,
            accept: () => onAprobar(rowData),
            reject: () => showMessage('info', translations.accioncancelada, translations.accioncancelada),
        });
    }, [estado, rowData, onAprobar, showMessage, translations]); */

    const handleVer = useCallback(() => {
      onVer(rowData);
    }, [onVer, rowData]);

    const handledownload = useCallback(async () => {
      if (estado === "CREADO") {
        showMessage(
          "error",
          translations.estadoincorrecto,
          translations.pedsinlistadeempaque,
        );
        return;
      }

      try {
        const response = await fetchWithAuth(
          `${API_URL}/api/editar-lista-empaque/${rowData.idpedido}`,
        );
        const data = await response.json();

        if (!data || data.length === 0) {
          showMessage("warn", translations.advertencia, translations.noDatos);
          return;
        }

        const columnasEsperadas = [
          { field: "nroCaja", header: "NUMERO DE CAJA" },
          { field: "RefInterna", header: "REFERENCIA PRODUCTO" },
          { field: "RefProveedor", header: "REFERENCIA PROVEEDOR" },
          { field: "ImagenProducto", header: "FOTO" },
          { field: "MarcaCaja", header: "MARCA" },
          { field: "Descripcion", header: "DESCRIPCION" },
          { field: "Material", header: "MATERIAL" },
          { field: "Serial", header: "SERIAL" },
          { field: "MarcaProducto", header: "MARCA (PRODUCTO)" },
          { field: "UnidadMedida", header: "UNIDAD DE MEDIDA" },
          { field: "Modelo", header: "MODELO" },
          { field: "PesoBruto", header: "PESO_BRUTO" },
          { field: "CantCajas", header: "CANTIDAD DE CAJAS" },
          { field: "CantPiezasPorCaja", header: "CANTIDADA DE PCS POR CAJA" },
          { field: "CantTotal", header: "CANTIDAD TOTAL" },
          { field: "CBMTotal", header: "CBM TOTAL" },
          { field: "CubCaja", header: "CUBICAJE / CAJA" },
          { field: "PesoCaja", header: "PESO / CAJA" },
          { field: "TipoMcia", header: "TIPO MCIA" },
          { field: "Importador", header: "IMPORTADOR" },
        ];

        const headers = columnasEsperadas.map((col) => col.header);
        const fields = columnasEsperadas.map((col) => col.field);

        const ws_data = [
          ["Packing List (装箱单)"], // Fila 1
          [], // Fila 2
          [
            "Por favor, tenga en cuenta que cada columna contiene un comentario con instrucciones detalladas. Coloque el cursor sobre el pequeño triángulo rojo en la esquina superior derecha de cada celda para ver el comentario.",
          ], // Fila 3
          [
            "请注意，每一列的标题单元格都包含详细说明的批注。将鼠标悬停在单元格右上角的小红三角上即可查看批注。",
          ], // Fila 4 (traducción china)
          [], // Fila 5
          [], // Fila 6
          headers, // Fila 7: Encabezados de la tabla
        ];

        data.forEach((row) => {
          const rowValues = fields.map((field) => row[field] || "");
          ws_data.push(rowValues);
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Lista de Empaque");
        worksheet.addRows(ws_data);

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `Lista_Empaque_Pedido_${rowData.idpedido}.xlsx`);

        showMessage(
          "success",
          translations.text_Confirmacion,
          translations.descargaExitosa,
        );
      } catch (err) {
        console.error("Error al descargar la lista de empaque:", err);
        showMessage(
          "error",
          translations.title_error,
          `${translations.erroraldescargar}: ${err.message}`,
        );
      }
    }, [estado, rowData, showMessage, translations]);

    const botones = useMemo(
      () => (
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {" "}
          {/* [DEBUG] Borde rojo */}
          {/* <Button
                icon="pi pi-arrow-up"
                className="p-button-rounded p-button-info"
                tooltip={translations.tooltip_Cargar}
                tooltipOptions={{ position: 'top' }}
                onClick={handleCargar}
            />
            <Button
                icon="pi pi-check-circle"
                className="p-button-rounded p-button-info"
                tooltip={translations.tooltip_Aprobar}
                tooltipOptions={{ position: 'top' }}
                onClick={handleAprobar}
            /> */}
          <Button
            id={`btn-historico-ver-${rowData.idpedido}`}
            icon="pi pi-eye"
            className="p-button-rounded p-button-info"
            tooltip={translations.tooltip_Ver}
            tooltipOptions={{ position: "top" }}
            onClick={handleVer}
          />
          <Button
            id={`btn-historico-descargar-${rowData.idpedido}`}
            icon="pi pi-download"
            className="p-button-rounded p-button-info"
            tooltip={translations.tooltip_Descargar || "Descargar"} // [EXPERT_FIX]: Fallback por seguridad
            tooltipOptions={{ position: "top" }}
            onClick={handledownload}
          />
        </div>
      ),
      [handleVer, handledownload, translations, rowData.idpedido],
    );

    return botones;
  },
);

export default React.memo(BotonesHistorico);
